import { ProfitProductSale } from '../models';
import { IBoundedContext } from '../../../config';
import { ProfitLossFilter } from '../models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService, ConfigService} from '../../../shared/services';

@Injectable()
export class ProfitProductSaleService {

    private _bi: IBoundedContext;

    constructor(
        private _api: ApiService,
        private configService: ConfigService) {
        this._bi = this.configService.getContext('bi');
    }

    getProductSaleList(filter: ProfitLossFilter): Observable<ProfitProductSale[]> {

        return this._api.get(this._bi.url, 'inventory/sold', filter)
            .map(productsales => productsales.map(sale => new ProfitProductSale
            (
                sale.product.name,
                sale.quantity,
                sale.subtotal,
                sale.tax)
            ))
            .cache();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/shared/services/profit-product-sale.service.ts